import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { tr } from "../../i18n";
import "../../assets/css/radioButtonGroup.css";

const leaveOptions = [
  { label: "LWP", value: "LWP" },
  { label: "LWOP", value: "LWOP" },
  { label: "SL", value: "SL" },
];

const RadioAttendanceCategory = ({ name = "category" }) => {
  const { watch, setValue, register } = useFormContext();
  const selectedValue = watch(name);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    register(name, { required: `${name} is required.` });
  }, [register, name]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectCategory = (value) => {
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
    setIsDropdownOpen(false);
  };

  const isLeaveSelected = leaveOptions.some(
    (opt) => opt.value === selectedValue,
  );

  return (
    <div className="radio-group" style={{ width: "100%" }}>
      <label
        className={`radio-button ${selectedValue === "Attendance" ? "selected" : ""}`}
      >
        <input
          type="checkbox"
          checked={selectedValue === "Attendance"}
          onChange={() => selectCategory("Attendance")}
        />
        <span className="radio-label">{tr("common:menu.attendance")}</span>
      </label>

      <label
        className={`radio-button ${selectedValue === "Overtime" ? "selected" : ""}`}
      >
        <input
          type="checkbox"
          checked={selectedValue === "Overtime"}
          onChange={() => selectCategory("Overtime")}
        />
        <span className="radio-label">{tr("attendance:overtime")}</span>
      </label>

      <div ref={dropdownRef} style={{ position: "relative" }}>
        <button
          type="button"
          className={`radio-button ${isLeaveSelected ? "selected" : ""}`}
          onClick={() => setIsDropdownOpen((prev) => !prev)}
          style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <span className="radio-label">{tr("attendance:leave")}</span>
          {isLeaveSelected && (
            <span className="badge bg-light text-dark">{selectedValue}</span>
          )}
          <span style={{ fontSize: "12px" }}>{isDropdownOpen ? "▲" : "▼"}</span>
        </button>

        {isDropdownOpen && (
          <div
            className="dropdown-menu show p-2"
            style={{ minWidth: "180px", zIndex: 20 }}
          >
            {leaveOptions.map((option) => (
              <label
                key={option.value}
                className="dropdown-item d-flex align-items-center gap-2"
                style={{ cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  checked={selectedValue === option.value}
                  onChange={() => selectCategory(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RadioAttendanceCategory;
